import { useTheme } from "../../../../../theme";

export default function MiniChip({ label, active, onClick, color, disabled, size = "sm" }) {
  const t = useTheme();
  const lg = size === "lg";
  return (
    <button onClick={onClick} disabled={disabled} style={{
      background: active ? `${color}${lg ? "20" : "18"}` : "transparent",
      border: `1px solid ${active ? `${color}${lg ? "55" : "40"}` : lg ? t.border : t.borderSubtle}`,
      borderRadius: lg ? 8 : 5,
      padding: lg ? "8px 18px" : "3px 8px",
      color: active ? color : lg ? t.textLow : t.textLow,
      fontFamily: "'DM Mono', monospace",
      fontSize: lg ? 12 : 9.5,
      cursor: disabled ? "not-allowed" : "pointer",
      transition: "all 0.2s ease",
      fontWeight: active ? 600 : 400,
      whiteSpace: "nowrap",
      lineHeight: 1.3,
      opacity: disabled ? 0.3 : 1,
      boxShadow: active && lg ? `0 0 16px ${color}22` : "none",
      letterSpacing: lg ? "0.04em" : "0",
      minHeight: lg ? 40 : "auto",
    }}>{label}</button>
  );
}
